import image from "../assets/images/r-bg.png";
import React from "react";
import {Link} from "react-router-dom";

const ResultsSection = () => {

    const backgroundStyle = {
        backgroundImage: `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
    };

    return (
        <div style={backgroundStyle} className={'bg-black w-screen px-12 py-24 text-white text-center flex flex-col items-center'}>
            <h1 className={'text-2xl font-semibold mb-4'}>Check Your Results Online</h1>
            <div className={'lg:w-1/2 md:2/3 mb-8'}>
                <p className={''}>View your latest exam results quickly and securely. Simply click the button below to
                    access the results
                    portal.</p>
            </div>
            <Link to={'/results'}>
                <button className="bg-yellow py-2 px-4 rounded-md mt-4 font-semibold w-max">
                    Check Results
                </button>
            </Link>
        </div>
    )
}

export default ResultsSection
